import React from 'react'

const GlobeIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  const strokeWidth = props.strokeWidth || '1'
  return (
    <svg
      width={width}
      height={height}
      fill={color}
      className='language'
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fillRule="nonzero">
        <path d="M8.792 21.195a.486.486 0 0 1-.405-.217L6.62 18.325A2.392 2.392 0 0 1 4.5 15.951V7.39A2.392 2.392 0 0 1 6.889 5h8.562a2.392 2.392 0 0 1 2.39 2.389.486.486 0 0 1-.973 0c0-.781-.636-1.416-1.417-1.416H6.89c-.781 0-1.416.635-1.416 1.416v8.562c0 .782.635 1.417 1.416 1.417.163 0 .314.081.405.216l1.498 2.248 1.498-2.248a.486.486 0 0 1 .405-.216h1.902a.486.486 0 0 1 0 .972h-1.642l-1.759 2.638a.486.486 0 0 1-.404.217z" />
        <path d="M18.305 25a.486.486 0 0 1-.461-.332l-.84-2.522h-.601a2.392 2.392 0 0 1-2.39-2.39v-8.561a2.392 2.392 0 0 1 2.39-2.39h8.562a2.392 2.392 0 0 1 2.389 2.39v8.562a2.392 2.392 0 0 1-2.39 2.389h-4.496l-1.758 2.637a.487.487 0 0 1-.405.217zM16.403 9.778c-.781 0-1.417.635-1.417 1.417v8.562c0 .781.636 1.416 1.417 1.416h.95c.21 0 .396.134.462.333l.637 1.91 1.351-2.026a.486.486 0 0 1 .405-.217h4.757c.781 0 1.416-.635 1.416-1.416v-8.562c0-.782-.635-1.417-1.416-1.417h-8.562z" />
        <path d="M21.16 16.438a.486.486 0 0 1-.487-.487v-3.805a.486.486 0 0 1 .973 0v3.805a.486.486 0 0 1-.487.487z" />
        <path d="M18.306 18.34a.486.486 0 0 1-.27-.89l2.854-1.903a.486.486 0 1 1 .54.809l-2.855 1.903a.484.484 0 0 1-.27.081z" />
        <path d="M24.013 18.34a.484.484 0 0 1-.27-.081l-2.853-1.903a.486.486 0 0 1 .54-.81l2.853 1.904a.486.486 0 0 1-.27.89zM24.014 14.535h-5.709a.486.486 0 0 1 0-.973h5.709a.486.486 0 0 1 0 .973zM13.549 15.486a.486.486 0 0 1-.447-.294l-2.47-5.763-3.32 5.812a.486.486 0 1 1-.845-.482l3.805-6.66a.486.486 0 0 1 .869.05l2.854 6.66a.486.486 0 0 1-.446.677z" />
        <path d="M12.217 12.632H8.792a.486.486 0 0 1 0-.972h3.425a.486.486 0 0 1 0 .972z" />
      </g>
    </svg>
  )
}

export default GlobeIcon
